import { render, staticRenderFns } from "./LabelsList.vue?vue&type=template&id=95503d94&scoped=true"
import script from "./LabelsList.vue?vue&type=script&lang=js"
export * from "./LabelsList.vue?vue&type=script&lang=js"
import style0 from "./LabelsList.vue?vue&type=style&index=0&id=95503d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95503d94",
  null
  
)

export default component.exports